import React, { useEffect, createElement } from 'react';
import { TaekwondoNearMeHeroInfo } from './taekwondo-near-me/TaekwondoNearMeHeroInfo';
import { TaekwondoNearMeHeroForm } from './taekwondo-near-me/TaekwondoNearMeHeroForm';
import { TaekwondoNearMeBenefits } from './taekwondo-near-me/TaekwondoNearMeBenefits';
import { TaekwondoNearMeWhatYouLearn } from './taekwondo-near-me/TaekwondoNearMeWhatYouLearn';
import { TaekwondoNearMeReviews } from './taekwondo-near-me/TaekwondoNearMeReviews';
import { TaekwondoNearMeScheduleLocation } from './taekwondo-near-me/TaekwondoNearMeScheduleLocation';
import { TaekwondoNearMeFAQHeader } from './taekwondo-near-me/TaekwondoNearMeFAQHeader';
import { TaekwondoNearMeFAQQuestions } from './taekwondo-near-me/TaekwondoNearMeFAQQuestions';
import { TaekwondoNearMeFAQActions } from './taekwondo-near-me/TaekwondoNearMeFAQActions';
import { TaekwondoNearMeRelatedLinks } from './taekwondo-near-me/TaekwondoNearMeRelatedLinks';
import { TaekwondoNearMeFinalCTA } from './taekwondo-near-me/TaekwondoNearMeFinalCTA';
export function TaekwondoNearMe() {
  useEffect(() => {
    document.title = 'Taekwondo Near Me | Martial Arts Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Looking for Taekwondo or martial arts near Farmington Hills, Novi, Commerce or Livonia? Storm offers kids, adult and family classes. Free trial available.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Looking for Taekwondo or martial arts near Farmington Hills, Novi, Commerce or Livonia? Storm offers kids, adult and family classes. Free trial available.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-3456">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-3457">
        <div className="absolute inset-0 opacity-20" data-id="element-3458">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1200&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-3459" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-3460" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3461">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3462">
            <TaekwondoNearMeHeroInfo data-id="element-3463" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-3464">
              <TaekwondoNearMeHeroForm data-id="element-3465" />
            </div>
          </div>
        </div>
      </section>
      <TaekwondoNearMeBenefits data-id="element-3466" />
      <TaekwondoNearMeWhatYouLearn data-id="element-3467" />
      <TaekwondoNearMeReviews data-id="element-3468" />
      <TaekwondoNearMeScheduleLocation data-id="element-3469" />
      <section className="py-24 bg-off-white" data-id="element-3470">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3471">
          <TaekwondoNearMeFAQHeader data-id="element-3472" />
          <TaekwondoNearMeFAQQuestions data-id="element-3473" />
          <TaekwondoNearMeFAQActions data-id="element-3474" />
        </div>
      </section>
      <TaekwondoNearMeRelatedLinks data-id="element-3475" />
      <TaekwondoNearMeFinalCTA data-id="element-3476" />
    </div>;
}